"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createStyles = exports.MonthView = void 0;
var react_1 = __importStar(require("react"));
var styles_1 = require("../../styles");
var locale_1 = require("../../util/locale");
var util_1 = require("./util");
function MonthView(props) {
    var onlyWeeks = props.onlyWeeks, visibleDate = props.visibleDate, renderDay = props.renderDay, renderWeekName = props.renderWeekName, onDayClick = props.onDayClick, onDayHover = props.onDayHover, onWeekClick = props.onWeekClick, onWeekHover = props.onWeekHover, createDateStyles = props.createDateStyles;
    var _a = styles_1.useStyles(exports.createStyles), classes = _a.classes, css = _a.css;
    var month = react_1.useMemo(function () { return util_1.createMonthMatrix(visibleDate); }, [visibleDate]);
    var handleDayClick = react_1.useCallback(function (day) { return function () { return onDayClick(day); }; }, [onDayClick]);
    var handleDayHover = react_1.useCallback(function (day) { return function () { return onDayHover(day); }; }, [onDayHover]);
    var handleWeekClick = react_1.useCallback(function (week) { return function () { return onWeekClick(week); }; }, [onWeekClick]);
    var handleWeekHover = react_1.useCallback(function (week) { return function () { return onWeekHover(week); }; }, [onWeekHover]);
    return (react_1.default.createElement("table", { className: classes.table },
        react_1.default.createElement("thead", null,
            react_1.default.createElement("tr", null, month[0].map(function (day, d) { return (react_1.default.createElement("th", { key: d }, renderWeekName(day))); }))),
        react_1.default.createElement("tbody", null, month.map(function (week, w) { return (react_1.default.createElement("tr", { key: w, className: onlyWeeks ? css(classes.week, createDateStyles({ start: week[0], end: week[6] }, props)) : undefined, onClick: onlyWeeks ? handleWeekClick({ start: week[0], end: week[6] }) : undefined, onMouseOver: onlyWeeks ? handleWeekHover({ start: week[0], end: week[6] }) : undefined, "data-week": onlyWeeks ? week[0].toLocaleDateString('pt-BR') + "-" + week[6].toLocaleDateString('pt-BR') : undefined }, week.map(function (day, d) { return (react_1.default.createElement("td", { key: d, "data-date": onlyWeeks ? undefined : day.toISOString().slice(0, 10) },
            react_1.default.createElement("span", { className: onlyWeeks ? undefined : css(classes.day, createDateStyles(day, props)), onClick: onlyWeeks ? undefined : handleDayClick(day), onMouseOver: onlyWeeks ? undefined : handleDayHover(day), role: 'button', "aria-selected": onlyWeeks ? undefined : props.isDaySelected && props.isDaySelected(day) }, renderDay(day)))); }))); }))));
}
exports.MonthView = MonthView;
MonthView.defaultProps = {
    onDayClick: function () { return null; },
    onDayHover: function () { return null; },
    onWeekClick: function () { return null; },
    onWeekHover: function () { return null; },
    onlyWeeks: false,
    createDateStyles: function () { return null; },
    renderDay: function (day) {
        var dayFormatter = new Intl.DateTimeFormat(locale_1.getUserLocale(), { day: '2-digit' });
        return dayFormatter.format(day);
    },
    renderWeekName: function (firstWeekDay) {
        var weekFormatter = new Intl.DateTimeFormat(locale_1.getUserLocale(), { weekday: 'narrow' });
        return weekFormatter.format(firstWeekDay);
    },
};
exports.createStyles = function (theme) { return ({
    table: {
        borderCollapse: 'separate',
        textAlign: 'center',
        lineHeight: '1.5rem',
        width: '100%',
        borderSpacing: '0 0.25rem',
        th: {
            width: '2rem',
            padding: '0.25rem 0',
        },
        'tr td:first-child': {
            borderTopLeftRadius: '10%',
            borderBottomLeftRadius: '10%',
        },
        'tr td:last-child': {
            borderTopRightRadius: '10%',
            borderBottomRightRadius: '10%',
        },
    },
    day: {
        width: '2rem',
        padding: '0.25rem 0',
        display: 'inline-block',
        borderRadius: '50%',
        ':hover': {
            cursor: 'pointer',
            background: theme.pallete.surface.background,
        },
    },
    week: {
        padding: '0.25rem 0',
        ':hover': {
            cursor: 'pointer',
            background: theme.pallete.surface.background,
        },
    },
    active: {
        background: theme.pallete.primary.main,
        color: theme.pallete.surface.main,
    },
}); };
//# sourceMappingURL=MonthView.js.map